import React from "react";
import "./TextEditor.css";
import { DebounceInput } from "react-debounce-input";

export default function TexEditor({
  questionText,
  title,
  handleChange,
  strings
}) {
  return (
    <div className="TextEditor">
      <h3>{title}</h3>
      <DebounceInput
        element="textarea"
        type="text"
        name="question"
        debounceTimeout={300}
        placeholder={strings.questionSignPlaceholder}
        value={questionText}
        onChange={handleChange}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/TextEditor.js